export function normalizeApiBaseUrl(value: unknown): string {
  if (typeof value !== 'string' || !value.trim()) return '';
  try {
    const parsed = new URL(value.trim());
    if (!['http:', 'https:'].includes(parsed.protocol) || parsed.username || parsed.password || parsed.search || parsed.hash) return '';
    return parsed.toString().replace(/\/$/, '');
  } catch {
    return '';
  }
}

export function apiRequestTarget(input: RequestInfo | URL, apiBaseUrl: string): RequestInfo | URL {
  if (!apiBaseUrl || typeof input !== 'string' || !input.startsWith('/api/')) return input;
  return `${apiBaseUrl}${input}`;
}

export function apiResourceTarget(value: unknown, apiBaseUrl: string, pageOrigin: string): string | null {
  if (typeof value !== 'string' || !value) return null;
  if (!value.startsWith('/api/')) return value;
  return `${apiBaseUrl || pageOrigin}${value}`;
}
